import { SubmitHandler, useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { getSetting, updateSetting } from "../../api/setting";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../redux/hooks";
import { setAppLoading } from "../../redux/app.reducer";
import useSnackbar from "../../utils/snackbar";

const SettingCoversionRatePage = () => {
  const { data, isLoading, refetch } = useQuery("fetchSettings", async () => {
    return (await getSetting()).data;
  });
  const [openSnackbar] = useSnackbar({ position: "bottom-left" });
  const { register, handleSubmit, setValue } = useForm<{
    conversionRate: number;
  }>();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const onSubmit: SubmitHandler<{ conversionRate: number }> = async ({
    conversionRate,
  }) => {
    if (!data) return;
    setLoading(true);
    try {
      await updateSetting({
        conversionRate,
        commissionPercentage: data.commissionPercentage,
      });
      setLoading(false);
      refetch();
    } catch (e: any) {
      setLoading(false);
      let msg;
      if (typeof e?.response?.data?.message === "string") {
        msg = e?.response?.data?.message;
      }
      openSnackbar(msg || "Error: Something wrong.");
    }
  };

  useEffect(() => {
    if (data) {
      setValue("conversionRate", data.conversionRate);
    }
  }, [data]);

  useEffect(() => {
    dispatch(setAppLoading(isLoading || loading));
  }, [isLoading, loading]);

  return (
    <>
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <fieldset>
                <legend>อัตราการแลกเปลี่ยน</legend>
                <div className="form-group row">
                  <label
                    htmlFor=""
                    className="col-sm-3 col-form-label font-weight-bold"
                  >
                    1 THB =
                  </label>
                  <div className="col-sm-4">
                    <input
                      {...register("conversionRate", {
                        required: true,
                        valueAsNumber: true,
                      })}
                      type="number"
                      className="form-control"
                      placeholder="THB/KRW"
                      step={0.01}
                      min={0.01}
                    />
                  </div>
                  <label
                    htmlFor=""
                    className="col-sm-3 col-form-label font-weight-bold"
                  >
                    KRW
                  </label>
                </div>
              </fieldset>
              <div className="row">
                <div className="col-sm-3"></div>
                <div className="col-sm-4 text-right">
                  <button className="btn btn-primary" type="submit">
                    บันทึก
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingCoversionRatePage;
